export const GET_FORM_TWO = 'GET_FORM_TWO'
export const UPDATE_FORM_TWO = 'UPDATE_FORM_TWO'
export const DELETE_FORM_TWO = 'DELETE_FORM_TWO'

